import { Model } from "@danangelus/ngx-app-core"

export class SurveyData extends Model {

    name: string
    salesSurveyData: SalesSurveyData
    serviceSurveyData: ServiceSurveyData

    constructor(surveyData: any) {
        super(surveyData)

        this.name = surveyData.name
        this.salesSurveyData = new SalesSurveyData(surveyData.salesSurveyData)
        this.serviceSurveyData = new ServiceSurveyData(surveyData.serviceSurveyData)
    }

}

class SalesSurveyData extends Model {

    responseCount: number | undefined
    ltrTopBoxRating: number | undefined
    trustRating: number | undefined
    facilitiesRating: number | undefined
    staffRating: number | undefined
    welcomeRating: number | undefined
    easeOfPurchaseRating: number | undefined
    easeOfServiceRating: number | undefined
    contactRating: number | undefined
    testDriveRating: number | undefined
    dealershipRating: number | undefined
    invitationCount: number | undefined

    constructor(salesSurveyData: any) {
        super(salesSurveyData)

    }

}

class ServiceSurveyData extends Model {

    responseCount: number | undefined
    ltrTopBoxRating: number | undefined
    trustRating: number | undefined
    facilitiesRating: number | undefined
    staffRating: number | undefined
    firstTimeFixedPercent: number | undefined
    easeOfServiceRating: number | undefined
    readyAtAgreedTimePercent: number | undefined
    dealershipRating: number | undefined
    invitationCount: number | undefined

    constructor(serviceSurveyData: any) {
        super(serviceSurveyData)
    }
}
